import i10n from "../i10n";

export const GetUrl = (params) => {
    if (Array.isArray(params)){
        return `/${i10n.currentLang}/${params.join('/')}`;
    } else{
        return `/${i10n.currentLang}/${params}`;
    }
}